/* Copyright 2021, Milkdown by Mirone. */
export const shallowClone = (x) => {
    if (Array.isArray(x)) {
        return [...x];
    }
    if (typeof x === 'object') {
        return Object.assign({}, x);
    }
    return x;
};
//# sourceMappingURL=shallow-clone.js.map